<template>
  <wizard
    title="titles.fee.wizard"
    :tabs="tabs"
    :activeTab="activeTab"
    :hideFooter="true"
    :clickableTabs="false"
    @setActiveTab="setActiveTab"
  >
    <router-view @nextTab="nextTab" @previousTab="previousTab" @setActiveTab="setActiveTab" />
  </wizard>
</template>

<script>
import Wizard from '@/components/wizard/Wizard.vue';
import { wizardMixin } from '@/mixins/wizard';

// @vuese
// Komponent do zarządzania procedurą
export default {
  mixins: [wizardMixin],
  props: {
    // Zakładki wizarda
    tabs: {
      type: Array,
      required: true
    }
  }
};
</script>
